import React from 'react'
import { Navigate } from 'react-router-dom'
function RouteProtected({ isSignedIn, children }) {
  console.log("isSignedIn :: ", isSignedIn)
  if (!isSignedIn) {
    return <Navigate to="/" replace />
  }else if(localStorage.getItem('auth_key')=='xxaa1112jnj' ||  "kjnmgh22578" || "astrfh126643"){
    return children
  }
  
}
export default RouteProtected;